import React, { useCallback, useEffect, useState } from 'react';
import Link from 'next/link';

import { IMenuByTypesItem } from '@r1-frontend/api-domru/api-content/v2/menu/by-types/dto/IMenuByTypesItem';

import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';

import { EVENTS } from '@r1-frontend/shared/constants/analytics';

import * as ST from './styled';

interface IProps {
    children: IMenuByTypesItem[] | JSX.Element,
    title: string,
    link: string,
    isVisible: boolean,
    isAvailable: boolean,
    isPromoted: boolean,
    firstItem?: IMenuByTypesItem,
    onClick?: (item: string, menuType?: string) => void,
}

const Accordion = ({
    children,
    title,
    link,
    isVisible,
    isAvailable,
    firstItem,
    isPromoted,
}: IProps): JSX.Element => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        setIsOpen(firstItem?.title === title);
    }, []);

    const toggle = useCallback(() => {
        setIsOpen(!isOpen);
    }, [isOpen]);

    const onClickHandler = useCallback((item, menuType = 'Main menu') => {
        dataLayerPush({
            event: EVENTS.UAevent,
            category: `${menuType} click`,
            action: item,
            label: 'menu_new',
        });
    }, []);

    return (
        <ST.Wrapper isAvailable={isAvailable} open={isOpen}>
            <ST.AccordionTitle open={isOpen}>
                {isVisible
                    ? <ST.LinkItemDrop
                        open={isOpen}
                        isPromoted={isPromoted}
                    >
                        <ST.Title>{title}</ST.Title>
                    </ST.LinkItemDrop>
                    : <Link href={link} prefetch={false} passHref>
                        <ST.LinkItemDrop
                            onClick={() => onClickHandler(title)}
                            open={isOpen}
                            isPromoted={isPromoted}
                        >
                            <ST.Title itemProp='name'>{title}</ST.Title>
                        </ST.LinkItemDrop>
                    </Link>}
                <ST.Icon
                    open={isOpen}
                    onClick={toggle}
                    isVisible={isVisible}
                />
            </ST.AccordionTitle>
            <ST.AccordionBody open={isOpen}>
                {children}
            </ST.AccordionBody>
        </ST.Wrapper>
    );
};

export default Accordion;
